// extracted by mini-css-extract-plugin
export default {"contentWrapper":"VRiAIlsLayFrSKgDNF8U","textContainer":"DgD1ZlQTej2zUwGR9daG"};